module.exports = __webpack_public_path__ + "img/tip.74261558.svg";